module.exports = __webpack_public_path__ + "static/media/ino.ccf88661.png";